import React from 'react';
import PropTypes from 'prop-types';

import { ReactComponent as LogoDefault } from '../../assets/images/logo.svg';
import { ReactComponent as LogoReduced } from '../../assets/images/logo-small.svg';

const decoder = {
  reduced: LogoReduced,
  default: LogoDefault,
};

function Logo({ variant = 'default', ...props }) {
  return React.createElement(decoder[variant], props);
}

Logo.propTypes = {
  variant: PropTypes.string,
};

export { Logo };
